import Vue from 'vue'
import Video from '@/components/utils/video/VideoPlayer.vue'

Vue.component('nt-video', Video)
